import { getLogger as baseGetLogger } from '@logtape/logtape';

function serializeError(error: unknown) {
  if (error instanceof Error) {
    return { kind: error.name, message: error.message, stack: error.stack };
  }

  return error;
}

function buildProperties(meta?: unknown, error?: unknown): Record<string, unknown> {
  const metaIsError = meta instanceof Error;
  const isObject = typeof meta === 'object' && meta !== null && !metaIsError;
  const properties: Record<string, unknown> = isObject ? { ...(meta as Record<string, unknown>) } : {};
  const errorValue = error ?? (metaIsError ? meta : properties.error);

  if (errorValue === undefined) {
    delete properties.error;
  } else {
    properties.error = serializeError(errorValue);
  }

  return properties;
}

export function getLogger(context?: string) {
  const logger = baseGetLogger(context ? ['app', context] : ['app']);

  return {
    error(message: string, meta?: unknown, error?: unknown) {
      logger.error(message, buildProperties(meta, error));
    },

    info(message: string, meta?: unknown) {
      logger.info(message, buildProperties(meta));
    },

    warn(message: string, meta?: unknown) {
      logger.warn(message, buildProperties(meta));
    },

    debug(message: string, meta?: unknown) {
      logger.debug(message, buildProperties(meta));
    },
  };
}
